export default __webpack_public_path__ + "static/poster-main-video-4f0a413666442fb4bf785604e0a14196.webp";